// extracted by mini-css-extract-plugin
module.exports = {"container":"SashLayer_container__1_JbU","containerSmall":"SashLayer_containerSmall__3lZ-H","text":"SashLayer_text__33umJ","textSmall":"SashLayer_textSmall__3FA4q"};